const AppConfig = Object.freeze({
  STORAGE_KEYS: {
    token: "token",
    layout: "layout",
    user: "user",
    payment: "odt",
  },
  SOCIAL_LOGIN_TYPES: {
    FACEBOOK: "facebook",
    GOOGLE: "google",
    APPLE: 'apple'
  },
  LOGIN_TYPES: {
    ADMIN: 'ADMIN',
    CLIENT: 'CLIENT',
    WORKER: 'WORKER',
    COMPANY: 'COMPANY'
  },
  APPROVAL_STATUS: {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    REJECT: 'REJECT',
    WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL'
  },
  SYSTEM_STATUS: {
    ACTIVE: 'ACTIVE',
    DEACTIVATE: 'DEACTIVATE',
    TERMINATE: 'TERMINATE',
  },
  APPRAISAL_RATING: {
    MEETS: 'MEETS_EXPECTATION',
    EXCEEDS: 'EXCEEDS_EXPECTATION',
    BELOW: 'BELOW_EXPECTATIONS',
    NEEDS_IMPROVEMENT: 'NEED_IMPROVEMENT'
  },
  APPRAISAL_STATUS: {
    CURRENT: 'CURRENT',
    ARCHIVE: 'ARCHIVE'
  },
  DOCUMENT_STATUS: {
    PENDING: 'PENDING',
    DONE: 'DONE',
  },
  TRANSACTION_STATUS: {
    SUCCESS: 'SUCCESS',
    REFUND: 'REFUND',
    FAILED: 'FAILED'
  },
  PATTERNS: {
    GENERAL_DATE_FORMAT: "DD MMM YYYY",
    DATE_TIME_FORMAT: "DD MMM YYYY, hh.mm a",
    DATE_FORMAT: "MM/DD/YYYY",
    DECIMAL_NUMBER: /^(\d*\.)?\d+$/,
    INPUT_NUMBER: /^[+-]?(\d+([.]\d*)?(e[+-]?\d+)?|[.]\d+(e[+-]?\d+)?)$/,
    EMAIL_PATTERN: /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/,
    DOMAIN_PATTERN: /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
    IP_PATTERN: /^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/,
    PASSWORD_PATTERN: /^.{8,}$/,
    PASSWORD_UPPER: /^(?=.*[A-Z]).{1,}$/,
    PASSWORD_LOWER: /^(?=.*[a-z]).{1,}$/,
    PASSWORD_NUMBER: /^(?=.*\d).{1,}$/,
    DATE_PATTERN: /^(([01])\d)\/(([012])\d)\/((19|20)\d{2})$/,
    SECTION_PATTERN: /[A-E][1-9]-[1-9]|[A-E][1-9]/g,
    NUMBER_MAX_LENGTH_64: /^[0-9]{,64}$/,
    NUMBER_MAX_LENGTH_128: /^[0-9]{,128}$/,
    NUMBER_MAX_LENGTH_255: /^[0-9]{,255}$/,
    USER_GROUP_NAME: /^[a-zA-Z0-9_ -]*$/,
    BLANK_SPACES: /[^\s*]/g,
    POSTAL_CODE: /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/,
    XSS_PATTERN:/^[A-Za-z0-9~`!@#$%^&*()_+-=\s]*$/g,
    PRICE_FORMAT: /^[0-9]{1,5}(\.[0-9]{0,2})?$/,
    ADDRESS_PATTERN: /^[a-zA-Z0-9\s`~!@#^&*()\-_|;:'",.\/?]*$/
  },
  DATE_FORMAT: {
    DEFAULT: "DD/MM/YYYY",
    RANGE_PICKER: "dd/MM/yyyy",
  },
  DELIVERY_TYPES: {
    SELF_COLLECTION: "1",
    DELIVERY: "2",
  },
  DELIVERY_DATE_TYPES: {
    RANGE_DATES: 1,
    OTHER: 2,
  },
  USER_ROLES: {
    ADMIN: 'ADMIN',
    NURSE: 'NURSE',
    WORKER: 'WORKER'
  },
  WITHDRAW_STATUS: {
    DONE: 1,
    PENDING: 0,
    CANCEL: 2,
    ALL: "",
  },
  OMISE_LIMIT: {
    MAX: 20000,
    MIN: 1,
  }
});

export const TIME_RANGE = {
  TODAY: 1,
  YESTERDAY: 2,
  THIS_WEEK: 3,
  THIS_MONTH: 4,
};
export const STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
};
export const PAGINATION = {
  page: 1,
  size: 10,
};
export const PRODUCT_PAYMENT_TYPE = {
  PAYNOW: 1,
  CREDIT_AND_DEBIT_CARDS: 2,
};
export const CONFIRM_ACTION = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
};
export const ACCOUNT_TYPE = {
  CLIENT: 1,
  WORKER: 2,
  COMPANY: 3
};
export const ACCOUNTING_TYPE = { 
  XERO: 'XERO',
  QUICKBOOKS: 'QUICKBOOKS'
}
export const USER_CONFIG = {
  SYSTEM_ADMIN: {
    roleLevel: 1,
    landingPage: '/admin/dashboard'
  },
  USER: {
    roleLevel: 2,
    landingPage: '/'
  }
};
export const CLIENT_TYPE = {
  SINGLE_USER_HOSPITAL: 'SINGLE_USER_HOSPITAL',
  SINGLE_USER_COORDINATOR: 'SINGLE_USER_COORDINATOR',
  MULTIPLE_USER_HOSPITAL: 'MULTIPLE_USER_HOSPITAL',
  MULTIPLE_USER_COORDINATOR: 'MULTIPLE_USER_COORDINATOR',
  PARTICIPANT: 'PARTICIPANT',
  SUPPORT_COORDINATOR_PARTICIPANT: 'SUPPORT_COORDINATOR_PARTICIPANT'
};
export const SYSTEM_ROLE = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  COMPANY: 'COMPANY',
  MANAGER: 'MANAGER',
  HOSPITAL_ADMIN: 'HOSPITAL_ADMIN',
  HOSPITAL_OTHER: 'HOSPITAL_OTHER',
  COORDINATOR_ADMIN: 'COORDINATOR_ADMIN',
  COORDINATOR_OTHER: 'COORDINATOR_OTHER',
  PARTICIPANT: 'PARTICIPANT',
  NURSE: 'NURSE',
  SUPPORT_WORKER: 'SUPPORT_WORKER',
  SENIOR_SUPPORT_WORKER: 'SENIOR_SUPPORT_WORKER',
  TEAM_LEADER: 'TEAM_LEADER',
  HOUSE_COORDINATOR: 'HOUSE_COORDINATOR',
  REGISTERED_NURSE: 'REGISTERED_NURSE',
  CLINICAL_NURSE_MANAGER: 'CLINICAL_NURSE_MANAGER',
  OPERATIONS_MANAGER: 'OPERATIONS_MANAGER',
  HR_MANAGER: 'HR_MANAGER',
  DIRECTOR: 'DIRECTOR'
};
export const WORKER_TYPE = {
  NURSE: 'NURSE',
  SUPPORT_WORKER: 'SUPPORT_WORKER',
  SENIOR_SUPPORT_WORKER: 'SENIOR_SUPPORT_WORKER',
  TEAM_LEADER: 'TEAM_LEADER',
  HOUSE_COORDINATOR: 'HOUSE_COORDINATOR',
  REGISTERED_NURSE: 'REGISTERED_NURSE',
  CLINICAL_NURSE_MANAGER: 'CLINICAL_NURSE_MANAGER',
  OPERATIONS_MANAGER: 'OPERATIONS_MANAGER',
  HR_MANAGER: 'HR_MANAGER',
  DIRECTOR: 'DIRECTOR'
};
export const EMPLOYMENT_TYPE = {
  CASUAL: 'CASUAL',
  PART_TIME: 'PARTTIME',
  FULL_TIME: 'FULLTIME'
};
export const SHIFT_COLOR = {
  MORNING: '#2b7acf',
  AFTERNOON: '#e4b152',
  EVENING: '#ba5757',
  NIGHT: '#d6649a'
};
export const BILLING_TYPE = {
  PLAN_MANAGER: {
    id: 'PLAN_MANAGER',
    label: 'label.planManager'
  },
  NDIA: {
    id: 'NDIA',
    label: 'label.ndia'
  },
  SELF: {
    id: 'SELF',
    label: 'label.self'
  }
};
export const APPROVAL_STATUS = {
  PENDING: {
    id: 'PENDING',
    label: 'label.pending'
  },
  ACTIVE: {
    id: 'ACTIVE',
    label: 'label.active'
  },
  WAITING_FOR_APPROVAL: {
    id: 'WAITING_FOR_APPROVAL',
    label: 'label.waitingForApproval'
  },
  REJECT: {
    id: 'REJECT',
    label: 'label.reject'
  }
};
export const GENDER = {
  MALE: {
    id: 'MALE',
    label: 'label.male'
  },
  FEMALE: {
    id: 'FEMALE',
    label: 'label.female'
  },
  OTHER: {
    id: 'OTHER',
    label: 'label.other'
  }
};
export const WORKER_ACCREDITATION = {
  PRACTITIONER: {
    id: 1,
    label: 'label.civdDisabilitySupport'
  },
  REGISTERED: {
    id: 2,
    label: 'label.civdInAgedCare'
  }
};
export const NURSE_ACCREDITATION = {
  PRACTITIONER: {
    id: 3,
    label: 'label.nursePractitioner'
  },
  REGISTERED: {
    id: 4,
    label: 'label.registeredNurse'
  },
  ENROLLED: {
    id: 5,
    label: 'label.enrolledNurse'
  },
  ASSISTANT: {
    id: 6,
    label: 'label.assistantInNursing'
  }
};
export const JOB_STATUS = {
  AVAILABLE: 'AVAILABLE',
  ON_GOING: 'ON_GOING',
  DONE: 'DONE'
};
export const JOB_TYPE = {
  SINGLE_WORKER: 'SINGLE_WORKER',
  MULTIPLE_WORKER: 'MULTIPLE_WORKER'
};
export const PART_TYPE_CLIENT = {
  GENERAL_INFO: 'GENERAL_INFO',
  VERIFICATION: 'VERIFICATION',
  BILLING_INFO: 'BILLING_INFO',
  AGREEMENT: 'AGREEMENT'
};
export const PART_TYPE_COMPANY = {
  GENERAL_INFO: 'GENERAL_INFO',
  VERIFICATION: 'VERIFICATION',
  BILLING_INFO: 'BILLING_INFO',
  AGREEMENT: 'AGREEMENT'
}
export const PART_TYPE_WORKER = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  PROFESSIONAL_INFO: 'PROFESSIONAL_INFO',
  VERIFICATION: 'VERIFICATION',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  AGREEMENT: 'AGREEMENT'
};
export const BOOKING_STATUS = {
  BOOKED: 'BOOKED',
  WAITING: 'WAITING',
  ON_GOING: 'ON_GOING',
  CANCEL: 'CANCEL',
  DONE: 'DONE',
  AVAILABLE: 'AVAILABLE',
  REJECTED: 'REJECTED',
  NO_CLOCK_IN: 'NO_CLOCK_IN',
  NO_ACCEPTED: 'NO_ACCEPTED',
  EXPRESS_INTEREST: 'EXPRESS_INTEREST'
};
export const POST_JOB = {
  POST_JOB: 'POST_JOB',
  UNPOST_JOB: 'UNPOST_JOB'
};

export const FILE_STATUS = {
  DONE: 'DONE',
  ON_PROCESS: 'ON_PROCESS',
  PENDING: 'PENDING',
  REVIEW: 'REVIEW',
  VERIFIED: 'VERIFIED',
  EXPIRED: 'EXPIRED',
  NOT_UPLOADED: 'NOT_UPLOADED',
  OVERDUE: 'OVERDUE',
  UPLOADING: 'UPLOADING',
  PAST: 'PAST'
};

export const QUESTION_TYPE = {
  DEFAULT: 'DEFAULT',
  YES_NO: 'YES_NO'
}

export const maxFileSize = 2000000; // decimal

export const COMPLIANCE_STATE = {
  VIC: 'VIC',
  NSW: 'NSW',
  QLD: 'QLD',
  SA: 'SA',
  WA: 'WA',
  TAS: 'TAS',
  ACT: 'ACT',
  NT: 'NT'
};

export const NDIS_ORIENTATIONS_LINK = {
  MANDATORY_WORKER: 'https://training.ndiscommission.gov.au/',
  SCREENING_CHECK: 'https://www.ndiscommission.gov.au/workers/worker-screening-workers'
};
export const WORK_STATUS = {
  AUSTRALIAN_CITIZEN: 'AUSTRALIAN_CITIZEN',
  NEW_ZEALAND_CITIZEN: 'NEW_ZEALAND_CITIZEN',
  AUSTRALIA_WORK_VISA: 'AUSTRALIA_WORK_VISA'
};
export const PAYROLL_STATUS = ['PAID', 'PAID_QB', 'NOT_YET'];
export const RATE_TYPE = ['STANDARD','CUSTOM' ];
export const DAY_TYPE = ['WEEK_DAY', 'SAT_WEEK_END', 'WEEK_END', 'HOLIDAY'];
export const YEARS_OF_EXPERIENCE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const HOURS_PICKER = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
export const HOURS_PICKER_SLEEPOVER = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5, 6];
export const MINUTES_PICKER = [0 ,5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
export const MASK = {
  PHONE: '999999999999999'
}
export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
export const SHIFT = ['MORNING', 'AFTERNOON', 'EVENING', 'NIGHT'];
export const IMAGE_ACCEPT = 'image/jpeg, image/png, image/svg+xml, image/x-icon';
export const EXCEPT_ERRORS = [618];
export const MONTH_OR_YEAR = ['MONTH', 'YEAR'];
export const ADMIN_PERMISSIONS = {
  dashboard: {
    id: 'FULL_ACCESS_DASHBOARD',
    label: 'admin_permission.FULL_ACCESS_DASHBOARD'
  },
  users: {
    id: 'FULL_ACCESS_USERS',
    label: 'admin_permission.FULL_ACCESS_USERS'
  },
  company: {
    id: 'FULL_ACCESS_COMPANY',
    label: 'admin_permission.FULL_ACCESS_COMPANY'
  },
  jobs: {
    id: 'FULL_ACCESS_JOBS',
    label: 'admin_permission.FULL_ACCESS_JOBS'
  },
  workers: {
    id: 'FULL_ACCESS_WORKERS',
    label: 'admin_permission.FULL_ACCESS_WORKERS'
  },
  search_workers: {
    id: 'FULL_ACCESS_SEARCH_WORKERS',
    label: 'admin_permission.FULL_ACCESS_SEARCH_WORKERS'
  },
  clients: {
    id: 'FULL_ACCESS_CLIENTS',
    label: 'admin_permission.FULL_ACCESS_CLIENTS'
  },
  booking: {
    id: 'FULL_ACCESS_BOOKING',
    label: 'admin_permission.FULL_ACCESS_BOOKING'
  },
  rates: {
    id: 'FULL_ACCESS_RATES',
    label: 'admin_permission.FULL_ACCESS_RATES'
  },
  billing: {
    id: 'FULL_ACCESS_BILLING',
    label: 'admin_permission.FULL_ACCESS_BILLING'
  },
  payroll: {
    id: 'FULL_ACCESS_PAYROLL',
    label: 'admin_permission.FULL_ACCESS_PAYROLL'
  },
  subscriptions: {
    id: 'FULL_ACCESS_SUBSCRIPTIONS',
    label: 'admin_permission.FULL_ACCESS_SUBSCRIPTIONS'
  },
  options: {
    id: 'FULL_ACCESS_OPTIONS',
    label: 'admin_permission.FULL_ACCESS_OPTIONS'
  },
  subscriptionPlan: {
    id: 'FULL_ACCESS_SUBSCRIPTION_PLAN',
    label: 'admin_permission.FULL_ACCESS_SUBSCRIPTION_PLAN'
  },
  transactions: {
    id: 'FULL_ACCESS_TRANSACTIONS',
    label: 'admin_permission.FULL_ACCESS_TRANSACTIONS'
  },
  accountSoftware: {
    id: 'FULL_ACCESS_ACCOUNT_SOFTWARE',
    label: 'admin_permission.FULL_ACCESS_ACCOUNT_SOFTWARE'
  },
  paymentGateway: {
    id: 'FULL_ACCESS_PAYMENT_GATEWAY',
    label: 'admin_permission.FULL_ACCESS_PAYMENT_GATEWAY'
  },
  complaints: {
    id: 'FULL_ACCESS_COMPLAINTS',
    label: 'admin_permission.FULL_ACCESS_COMPLAINTS'
  }
}

export const DOWNLOAD_FILE_TYPES = [
  'text/csv',
  'application/pdf',
  'application/octet-stream'
];

export const DAYS = [
  {
    label: 'days.monday',
    shortText: 'Mon',
    key: 'monday',
  },
  {
    label: 'days.tuesday',
    shortText: 'Tue',
    key: 'tuesday'
  },
  {
    label: 'days.wednesday',
    shortText: 'Wed',
    key: 'wednesday'
  },
  {
    label: 'days.thursday',
    shortText: 'Thu',
    key: 'thursday'
  },
  {
    label: 'days.friday',
    shortText: 'Fri',
    key: 'friday'
  },
  {
    label: 'days.saturday',
    shortText: 'Sat',
    key: 'saturday'
  },
  {
    label: 'days.sunday',
    shortText: 'Sun',
    key: 'sunday'
  }
];

export const BILLING_STATUS = {
  PAID: 'PAID',
  PAID_QB: 'PAID_QB',
  NOT_PAID: 'NOT_PAID'
}

export const NOTIFICATION_TYPES = {
  BOOKING: 'BOOKING',
  COORD_PARTICIPANT: 'COORD_PARTICIPANT',
  JOB: 'JOB',
  BILLING: 'BILLING',
  PAYROLL: 'PAYROLL',
  WORKER_POINT: 'WORKER_POINT',
  RATING: 'RATING',
  NEAR_START_BOOKING: 'NEAR_START_BOOKING',
  AFTER_START_TIME_BOOKING: 'AFTER_START_TIME_BOOKING',
  ON_BOARD: 'ON_BOARD',
  AFTER_END_TIME_BOOKING: 'AFTER_END_TIME_BOOKING',
  NEAR_END_TIME_BOOKING_FIVE_MINUTE: 'NEAR_END_TIME_BOOKING_FIVE_MINUTE',
  NEAR_END_TIME_BOOKING_TEN_MINUTE: 'NEAR_END_TIME_BOOKING_TEN_MINUTE',
  EXTEND_BOOKING_TIME_REQUEST: 'EXTEND_BOOKING_TIME_REQUEST',
  APPROVED_EXTEND_BOOKING_TIME_REQUEST: 'APPROVED_EXTEND_BOOKING_TIME_REQUEST',
  REJECTED_EXTEND_BOOKING_TIME_REQUEST: 'REJECTED_EXTEND_BOOKING_TIME_REQUEST',
  APPRAISAL: 'APPRAISAL',
  NDIS_WORKER_SCREENING_EXPIRE: 'NDIS_WORKER_SCREENING_EXPIRE',
  FIRST_AID_AND_CPR_EXPIRE: 'FIRST_AID_AND_CPR_EXPIRE',
  ONBOARD_WORKER_ACTIVE: 'ONBOARD_WORKER_ACTIVE',
  ONBOARD_WORKER_REJECT: 'ONBOARD_WORKER_REJECT',
  PROCESS_NOTE_CREATED: 'PROCESS_NOTE_CREATED',
  PROCESS_NOTE_RESUBMISSION_REQUEST: 'PROCESS_NOTE_RESUBMISSION_REQUEST',
  PROCESS_NOTE_RESUBMITTED: 'PROCESS_NOTE_RESUBMITTED',
  INFECTION_CONTROL_EXPIRE: 'INFECTION_CONTROL_EXPIRE',
  MEDICATION_MANAGEMENT_EXPIRE: 'MEDICATION_MANAGEMENT_EXPIRE',
  INTAKE_LINK_SUBMITTED: 'INTAKE_LINK_SUBMITTED',
  INCIDENT_NOTIFIABLE: 'INCIDENT_NOTIFIABLE',
}

export const AUTH_STATUS_ERROR_CODE = [
  401, // unauthorized token
  410 // invalid token
]
export const LIMIT_MINUTES_CREATE_JOB = 5;

export const EXTEND_TIME_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'APPROVED',
  REJECTED: 'REJECTED'
}

export const RISK_CATEGORY = {
  BEHAVIOUR: 'Behaviour',
  MEDICAL: 'Medical',
  PHYSICAL: 'Physical',
  ENVIRONMENTAL: 'Environmental',
  COMMUNITY: 'Community',
  FINANCIAL: 'Financial',
  OTHER: 'Other'
};

export const RISK_SEVERITY = {
  EXTREME: 'Extreme',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low'
};

export const RISK_LIKELIHOOD = {
  ALMOST_CERTAIN: 'Almost_certain',
  LIKELY: 'Likely',
  POSSIBLE: 'Possible',
  UNLIKELY: 'Unlikely',
  RARE: 'Rare'
};

export const RISK_STATUS = {
  ACTIVE: 'Active',
  RESOLVED: 'Resolved',
  MONITORING: 'Monitoring'
};

export const CONSENT_STATUS = {
  PENDING: 'Pending',
  SIGNED: 'Signed',
  VERBAL: 'Verbal'
};

export const CLIENT_DOCUMENT_CATEGORY = {
  NDIS: 'NDIS',
  LEGAL: 'LEGAL',
  CLINICAL: 'CLINICAL',
  COMPLIANCE: 'COMPLIANCE',
  CONSENT: 'CONSENT'
};

export const CLIENT_DOCUMENT_STATUS = {
  PENDING: 'PENDING',
  CURRENT: 'CURRENT',
  SIGNED: 'SIGNED',
  REVIEW_DUE: 'REVIEW_DUE',
  OVERDUE: 'OVERDUE',
  SUPERSEDED: 'SUPERSEDED'
};

export const RECIPIENT_TYPE = {
  SUPPORT_COORDINATOR: 'SUPPORT_COORDINATOR',
  FAMILY_MEMBER_OR_GUARDIAN: 'FAMILY_MEMBER_OR_GUARDIAN',
  NOMINEE: 'NOMINEE',
  PARTICIPANT: 'PARTICIPANT'
}

export const NDIS_SUPPORT_CATEGORY = {
  CORE_SUPPORTS: 'CORE_SUPPORTS',
  CAPACITY_BUILDING: 'CAPACITY_BUILDING',
  CAPITAL_SUPPORTS: 'CAPITAL_SUPPORTS',
};

export const MEASUREMENT_METHOD = {
  MILESTONE: 'MILESTONE',
  PERCENTAGE: 'PERCENTAGE',
  FREQUENCY_COUNT: 'FREQUENCY_COUNT',
  OBSERVATION: 'OBSERVATION',
};

export const GOAL_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  ACHIEVED: 'ACHIEVED',
  DISCONTINUED: 'DISCONTINUED',
};

export const SUPPORT_CATEGORY_SUBCATEGORY = {
  SIL: 'SIL',
  DAILY_ACTIVITIES: 'DAILY_ACTIVITIES',
  COMMUNITY_PARTICIPATION: 'COMMUNITY_PARTICIPATION',
};

export const COMPLAINT_STATUS = {
  RECEIVED: 'RECEIVED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  OUT_COME_DECIDED: 'OUT_COME_DECIDED',
  CLOSED: 'CLOSED',
};

export const COMPLAINT_SUBMITTER_TYPE = {
  PARTICIPANT: 'PARTICIPANT',
  FAMILY_GUARDIAN: 'FAMILY_GUARDIAN',
  WORKER: 'WORKER',
  OTHER: 'OTHER',
};

export const COMPLAINT_OUTCOME = {
  UPHELD: 'UPHELD',
  PARTIALLY_UPHELD: 'PARTIALLY_UPHELD',
  NOT_UPHELD: 'NOT_UPHELD',
};

export const INCIDENT_STATUS = {
  OPEN: 'OPEN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
};

export const INCIDENT_STATUS_ORDER = ['OPEN', 'UNDER_REVIEW', 'RESOLVED', 'CLOSED'];

export const INCIDENT_SEVERITY = {
  LOW: 'LOW',
  MODERATE: 'MODERATE',
  SERIOUS: 'SERIOUS',
  NOTIFIABLE: 'NOTIFIABLE',
};

export const INCIDENT_TYPE = {
  VERBAL_AGGRESSION: 'VERBAL_AGGRESSION',
  PHYSICAL_AGGRESSION_TOWARD_PERSON: 'PHYSICAL_AGGRESSION_TOWARD_PERSON',
  PHYSICAL_AGGRESSION_TOWARD_PROPERTY: 'PHYSICAL_AGGRESSION_TOWARD_PROPERTY',
  SELF_HARM: 'SELF_HARM',
  ELOPEMENT_OR_ABSCONDING: 'ELOPEMENT_OR_ABSCONDING',
  FALL_OR_INJURY: 'FALL_OR_INJURY',
  MEDICATION_INCIDENT: 'MEDICATION_INCIDENT',
  UNAUTHORISED_RESTRICTIVE_PRACTICE: 'UNAUTHORISED_RESTRICTIVE_PRACTICE',
  ABUSE_OR_NEGLECT: 'ABUSE_OR_NEGLECT',
  OTHER: 'OTHER',
};

export const ACTION_SOURCE = {
  INCIDENT: 'INCIDENT',
  INVESTIGATION: 'INVESTIGATION',
  COMPLAINT: 'COMPLAINT',
  AUDIT_FINDING: 'AUDIT_FINDING',
  SUPERVISION: 'SUPERVISION',
  GOVERNANCE_KPI: 'GOVERNANCE_KPI',
  HR: 'HR',
  PARTICIPANT: 'PARTICIPANT',
  STAFF: 'STAFF',
  COMPLIANCE: 'COMPLIANCE',
  OTHER: 'OTHER',
};

export const ACTION_STATUS = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  OVERDUE: 'OVERDUE',
};

export const ACTION_OWNER = {
  WORKER: 'WORKER',
  PARTICIPANT: 'PARTICIPANT',
  COMPANY: 'COMPANY',
};

export const ACTION_PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
};

export default AppConfig;
